import Log from '@lib/Log';
import md5 from 'md5-js';

export const GTM_EVENT_LEAD = 'lead';
export const GTM_EVENT_START_QUIZ = 'start_quiz';
export const GTM_EVENT_COMPLETE_QUIZ = 'complete_quiz';
export const GTM_EVENT_COMPLETE_FULL_QUIZ = 'complete_full_quiz';
export const GTM_EVENT_SIGNUP = 'signup';

export function sendGtmEvent(name: string) {
  try {
    window.dataLayer.push({
      event: name
    });
    Log.info('Pixel', name);
  } catch(e) {
    Log.error('Pixel', 'GTM not available ${e}');
  }
}

const Pixels = {
  firedLead: false,
  firedStartQuiz: false,
  firedCompleteQuiz: false,
  firedCompleteFullQuiz: false,
  firedSignup: false,

  callEvent: function() {
    sendGtmEvent('call');
  },

  lead: function(leadId: string, email: string) {
    if (Pixels.firedLead) {
      Log.info('Pixel', `already fired ${GTM_EVENT_LEAD}`);
      return
    }
    Pixels.firedLead = true;

    let emailHash = '';
    try {
      emailHash = md5(email);
    } catch(e) {
      Log.warn('[Pixel] md5 not available');
    }

    try {
      window.dataLayer.push({
        'event': 'lead',
        'lead_id': leadId,
        'customer_email': emailHash,
      });
      Log.info('Pixel', 'lead');
    } catch(e) {
      Log.error('Pixel', 'GTM not available ${e}');
    }
  },

  startQuiz: function() {
    if (Pixels.firedStartQuiz) {
      Log.info('Pixel', `already fired ${GTM_EVENT_START_QUIZ}`);
      return
    }
    Pixels.firedStartQuiz = true;
    sendGtmEvent(GTM_EVENT_START_QUIZ);
  },
  completeQuiz: function() {
    if (Pixels.firedCompleteQuiz) {
      Log.info('Pixel', `already fired ${GTM_EVENT_COMPLETE_QUIZ}`);
      return
    }
    Pixels.firedCompleteQuiz = true;
    sendGtmEvent(GTM_EVENT_COMPLETE_QUIZ);
  },
  completeFullQuiz: function() {
    if (Pixels.firedCompleteFullQuiz) {
      Log.info('Pixel', `already fired ${GTM_EVENT_COMPLETE_FULL_QUIZ}`);
      return
    }
    Pixels.firedCompleteFullQuiz = true;
    sendGtmEvent(GTM_EVENT_COMPLETE_FULL_QUIZ);
  },
  signup: function() {
    if (Pixels.firedSignup) {
      Log.info('Pixel', `already fired ${GTM_EVENT_SIGNUP}`);
      return
    }
    Pixels.firedSignup = true;
    sendGtmEvent(GTM_EVENT_SIGNUP)
  }
};

export default Pixels;
